<form [formGroup]="parentForm">
  <div formGroupName="riopsForm">
    <div class="subSectionHeaderWrapper">
      <div class="d-flex justify-content-between align-items-center subSectionHeader">
        <h5 class="m-0">RIOPs</h5>

        <div class="ms-auto d-flex align-items-center">
          <button
            type="button"
            class="btn btn-link p-0 text-decoration-none"
            (click)="openHelpModal.emit('riops')"
            data-bs-toggle="modal"
            data-bs-target="#helpModal"
            aria-label="Help"
          >
            <i class="bi bi-question-circle" style="font-size: 1.5rem; color: white"></i>
          </button>

          <i
            style="cursor: pointer; margin-left: 0.5rem"
            [ngClass]="{ 'bi-arrow-up-circle-fill': isThisSectionVisible, 'bi-arrow-down-circle-fill': !isThisSectionVisible }"
            (click)="toggleVisibility()"
          ></i>
        </div>
      </div>
    </div>
    <div [ngStyle]="{ display: isThisSectionVisible ? 'block' : 'none' }">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <si-newton-form-group label="Onboarding Price" [errorResolverMap]="{ required: 'Value is required' }">
            <input formControlName="riopsOnboardingPrice" type="number" step="any" [min]="0" siNewton />
            <div class="input-group-prepend">
              <span class="input-group-text">€</span>
            </div>
          </si-newton-form-group>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <si-newton-form-group label="Price per Year" [errorResolverMap]="{ required: 'Value is required' }">
            <input formControlName="riopsPricePerYear" type="number" step="any" [min]="0" siNewton />
            <div class="input-group-prepend">
              <span class="input-group-text">€ / year</span>
            </div>
          </si-newton-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <b class="subSubSectionHeader">RIOPs Service Selection</b>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p class="info">Please select in which years RIOPs service is requested</p>
        </div>
      </div>

      <div class="row" style="width: 95%; margin: auto; padding-bottom: 10px">
        <input type="number" formControlName="yearOfStartFix" hidden #yearOfStartFix />

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected1" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 1 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected2" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 2 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected3" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 3 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected4" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 4 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected5" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 5 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected6" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 6 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected7" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 7 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected8" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 8 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected9" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 9 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected10" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 10 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected11" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 11 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected12" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 12 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected13" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 13 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected14" type="checkbox" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row year">{{ stringToNumber(yearOfStartFix.value) + 14 }}</div>
          <div class="row checkBox">
            <div class="form-check">
              <input id="cb-enabled" formControlName="riopsYearSelected15" type="checkbox" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
